import React, { Fragment, useCallback } from 'react'
import cn from 'classnames'
import { TooltipDefinition } from '../../../Tooltip'
import { InformationFilled16 } from '@carbon/icons-react'

import { isNumber, isUndefined, noop } from 'lodash'
import './index.scss'

const Single = ({ data, size = 'sm', onClick = noop, isInteractive }) => {
  const { title, value } = data

  const renderContent = useCallback(() => {
    if (isUndefined(value)) return null
    if (isNumber(value) || value?.length < 26) {
      return <p className={cn(size)}>{value}</p>
    } else {
      const val = value?.slice(0, 5)
      return (
        <p>
          <TooltipDefinition
            tooltipText={value}
            align='center'
            direction='bottom'
          >
            <span className='dots'>{val}...</span>
            <InformationFilled16 className='info-icon' />
          </TooltipDefinition>
        </p>
      )
    }
  }, [value])

  return (
    <Fragment>
      <div
        className={cn('KPI-title', { 'is-interactive': isInteractive })}
        onClick={() => onClick(data)}
      >
        <h5>{title}</h5>
      </div>
      <div
        className={cn('KPI-value', { 'is-interactive': isInteractive })}
        onClick={() => onClick(data)}
      >
        {renderContent()}
      </div>
    </Fragment>
  )
}

export default Single
